import React from 'react';

import { FormProviderNew, Paragraph } from '@components/index';
import SubtitleSecondary from '@components/texts/SubtitleSecondary';

import { Container } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepProvider: React.FC<IProps> = ({ currentStep, changeStep }) => {
  return (
    <Container>
      <SubtitleSecondary textAlign="start" nameColor="black">
        Prestador
      </SubtitleSecondary>
      <Paragraph
        textAlign="start"
        nameColor="black"
        opacity={0.8}
        fontWeight={500}
      >
        Cadastre o prestador
      </Paragraph>
      <FormProviderNew
        forNewProvider={{
          advanceStep: () => {
            changeStep(currentStep + 1);
          },
        }}
      />
    </Container>
  );
};

export default StepProvider;
